<template>
  <div
    class="container-fluid d-flex flex-column justify-content-center align-items-center"
  >
    <div class="mt-4 text-center">
      <h1>
        {{ $t("Get the full experience!") }}
      </h1>
      <p class="fs-24">
        {{ $t("Start your free trial now to get unlimited content") }}
      </p>
    </div>
    <div class="mt-4">
      <img
        id="two-posters"
        :src="'/img/two-posters-' + poster + '.png'"
        :alt="$t('Get the full experience!')"
      />
    </div>
    <div class="action-buttons">
      <button
        v-if="router().options.history.state.back !== null"
        class="btn btn-outline-light btn-register mb-2 mx-auto"
        @click="router().go(-1)"
      >
        {{ $t("back") }}
      </button>
      <router-link
        class="btn btn-danger btn-register mb-2 mx-auto"
        :to="$t('routes.register')"
      >
        {{ $t("Free Trial") }}
      </router-link>
    </div>
    <div class="mt-4 clearfix"></div>
  </div>
</template>

<script>
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
import router from "@/router";

export default {
  name: "GetTheFullExperienceView",
  props: {
    poster: {
      type: String,
      required: false,
      default: "2",
    },
  },
  metaInfo: () => {
    return {
      title: i18n.global.t("Get the full experience!") + " | FlixLatino",
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("home.meta.description")),
      ],
    };
  },
  components: {},
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {
    this.$meta.canonicalUrls(
      this.$t("routes.get_the_full_experience", "es"),
      this.$t("routes.get_the_full_experience", "en")
    );
  },
  methods: {
    router() {
      return router;
    },
  },
};
</script>

<style lang="scss">
#two-posters {
  max-height: 50vh;
}

h1 {
  font-size: 3.5rem;
}

.btn-register {
  width: 20.875rem;
  height: 3rem;
  font-size: 1.125rem;
  align-content: center;
}

.fs-24 {
  font-size: 1.5rem !important;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap-reverse;
  flex-direction: row;
  column-gap: 2rem;
}

@media (max-width: 600px) {
  h1 {
    font-size: 2rem;
  }

  .fs-24 {
    font-size: 1.5rem !important;
  }

  #two-posters {
    max-height: 40vh;
  }
}
</style>
